import React from "react";

function Header() {
  return (
    <header className="header">
      <span>Employee Directory</span>
    </header>
  );
}

export default Header;
